import request from '../utils/request';
import type { InterviewPost, InterviewListResponse, ApiResponse } from '@/types';

export const getInterviewList = (params: Record<string, unknown> = {}): Promise<ApiResponse<InterviewListResponse>> => {
  return request.get('/blog/interview', { params }) as Promise<ApiResponse<InterviewListResponse>>;
};

export const getInterviewById = (postsId: number): Promise<ApiResponse<InterviewPost>> => {
  return request.get(`/blog/interview/${postsId}`) as Promise<ApiResponse<InterviewPost>>;
};

export const updateInterviewView = (postsId: number): Promise<ApiResponse<null>> => {
  return request.post('/blog/interview/view', { postsId }) as Promise<ApiResponse<null>>;
};

/** 面试管理 API（后台） */
export const interviewManageAPI = {
  /** 创建文章 */
  create: (data: {
    title: string;
    content: string;
    tag?: string;
  }): Promise<ApiResponse<{ id: number }>> =>
    request.post('/blog/interview/create', data) as Promise<ApiResponse<{ id: number }>>,

  /** 更新文章 */
  update: (postsId: number, data: Record<string, unknown>): Promise<ApiResponse<null>> =>
    request.post('/blog/interview/update', { postsId, ...data }) as Promise<ApiResponse<null>>,

  /** 删除文章 */
  delete: (postsId: number): Promise<ApiResponse<null>> =>
    request.post('/blog/interview/delete', { postsId }) as Promise<ApiResponse<null>>,
};
